import { FilterValue } from './types';

export const useMultiSelectHelpers = (
  internalFilter: FilterValue,
  valueOptions: Array<{ id: string; label: string }>,
  selectPlaceholder: string,
) => {
  const getSelectedValues = (): string[] => {
    if (Array.isArray(internalFilter.value)) {
      return internalFilter.value;
    }

    return internalFilter.value ? [internalFilter.value] : [];
  };

  const isValueSelected = (valueId: string): boolean => {
    const selectedValues = getSelectedValues();

    return selectedValues.includes(valueId);
  };

  const getDisplayValue = (): string => {
    const selectedValues = getSelectedValues();
    if (selectedValues.length === 0) return selectPlaceholder;
    if (selectedValues.length === 1) {
      const option = valueOptions.find((opt) => opt.id === selectedValues[0]);

      return option?.label || selectedValues[0];
    }

    return `${selectedValues.length} selected`;
  };

  return {
    getSelectedValues,
    isValueSelected,
    getDisplayValue,
  };
};
